// Inline-editable title — click to enter edit mode, Enter or blur to save,
// Escape to cancel. Used for renaming a dashboard from its detail page.
// Extracted from `pages/Dashboards.jsx` (iter 41 refactor) — no behaviour change.
import React, { useEffect, useRef, useState } from "react";
import { Pencil, Check } from "lucide-react";


export default function InlineEditableTitle({ value, onSave, testId }) {
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState(value);
    const inputRef = useRef(null);
    useEffect(() => { setDraft(value); }, [value]);
    useEffect(() => {
        if (editing) { inputRef.current?.focus(); inputRef.current?.select(); }
    }, [editing]);
    if (!editing) {
        return (
            <span onClick={() => setEditing(true)}
                    className="group inline-flex items-center gap-2 cursor-pointer hover:text-primary transition-colors"
                    title="Click to rename"
                    data-testid={testId}>
                <span>{value}</span>
                <Pencil className="h-5 w-5 opacity-40 group-hover:opacity-100 text-primary transition-opacity" strokeWidth={2} />
            </span>
        );
    }
    const commit = () => {
        const next = (draft || "").trim();
        setEditing(false);
        if (next && next !== value) onSave?.(next);
        else setDraft(value);
    };
    return (
        <div className="flex items-center gap-2" data-testid={`${testId}-editing`}>
            <input ref={inputRef} value={draft} onChange={(e) => setDraft(e.target.value)}
                   onBlur={commit}
                   onKeyDown={(e) => {
                       if (e.key === "Enter") { e.preventDefault(); commit(); }
                       if (e.key === "Escape") { setDraft(value); setEditing(false); }
                   }}
                   className="bg-transparent border-b border-primary outline-none text-2xl md:text-4xl font-medium min-w-[300px]"
                   data-testid={`${testId}-input`} />
            <Check className="h-4 w-4 text-primary cursor-pointer" onMouseDown={commit} />
        </div>
    );
}
